/**
 * * Enum del user frontdesk
 */
 export enum USERFRONTDESK {
    ROLE = 'FRONTDESK'
 }
 